var React = require('react');

function IcAwsOpsworksDeployments (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M35.366,32.159l-4.933,4.933V21.757c-0.009-0.787-0.408-1.514-1.059-1.941l-8.522-5.708V0h-1.703v14.108\n\tl-8.515,5.703c-0.658,0.431-1.057,1.158-1.066,1.955v15.326l-4.933-4.933L3.43,33.363l6.387,6.387C9.984,39.917,10.201,40,10.419,40\n\tc0.218,0,0.436-0.083,0.602-0.249l6.387-6.387l-1.204-1.204l-4.933,4.933V21.777c0.002-0.219,0.113-0.421,0.304-0.546L20,15.588\n\tl8.433,5.648c0.183,0.121,0.294,0.323,0.296,0.531v15.326l-4.933-4.933l-1.204,1.204l6.387,6.387C29.145,39.917,29.363,40,29.581,40\n\ts0.436-0.083,0.602-0.249l6.387-6.387L35.366,32.159z"}));
}

IcAwsOpsworksDeployments.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsOpsworksDeployments;

IcAwsOpsworksDeployments.default = IcAwsOpsworksDeployments;
